import { IBdi } from "common/interfaces";

export class WBSProjectData {
  wbsId: string;
  baseMonth: Date;
  projectTerm?: Number;
  landArea?: Number;
  privateUnits?: Number;
  builtArea?: Number;
  equivalentArea?: Number;
  privateArea?: Number;
  bdi?: IBdi;

  constructor(
    wbsId: string,
    baseMonth: Date,
    projectTerm: Number,
    landArea: Number,
    privateUnits: Number,
    builtArea: Number,
    equivalentArea: Number,
    privateArea: Number,
    bdi: IBdi
  ) {
    this.wbsId = wbsId;
    this.baseMonth = baseMonth;
    this.projectTerm = projectTerm;
    this.landArea = landArea;
    this.privateUnits = privateUnits;
    this.builtArea = builtArea;
    this.equivalentArea = equivalentArea;
    this.privateArea = privateArea;
    this.bdi = bdi;
  }
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/WBSProjectData.tsx